import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'cm-inline-alert',
    templateUrl: './inline-alert.component.html',
    styleUrls: ['./inline-alert.component.scss'],
    standalone: false
})
export class CmInlineAlert implements OnInit {
	@Input() type: 'info' | 'warn' | 'error' | 'danger' | 'success' = 'info';
	constructor() {}

	ngOnInit() {}
}
